import api from '@/utils/axios';
import { handleTokenError } from '@/utils/tokenHandler';

export default {
  namespaced: true,
  state: {
    user: {
      isLogged: false,
      name: null,
      email: null,
      status: null,
      role: null,
      id: null,
      shopId: null,
      shopName: null,
      shopAddress: null
    },
    isValidating: false,

    pagination: {
      page: 1,
      limit: 10,
      first: 0
    }
  },
  getters: {
    isUserEmail: (state) => {
      return state.user.email;
    },
    usersPagination: (state) => state.pagination,
    currentShop: (state) => ({
      id: state.user.shopId,
      name: state.user.shopName,
      address: state.user.shopAddress
    })
  },
  mutations: {
    loginUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = payload.jwt;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.role = payload.role;
      state.user.id = payload.id;
      state.user.shopId = payload.shopId;
      state.user.shopName = payload.shopName;
      state.user.shopAddress = payload.shopAddress;
      
      // Сохраняем все данные пользователя в localStorage
      try {
        localStorage.setItem('lbToken', payload.jwt || '');
        localStorage.setItem('lbEmail', payload.email || '');
        localStorage.setItem('lbName', payload.name || '');
        localStorage.setItem('lbStatus', payload.status || '');
        localStorage.setItem('lbRole', payload.role || '');
        localStorage.setItem('lbId', payload.id || '');
        localStorage.setItem('lbShopId', payload.shopId || '');
        localStorage.setItem('lbShopName', payload.shopName || '');
        localStorage.setItem('lbShopAddress', payload.shopAddress || '');
        localStorage.setItem('lbIsLogged', 'true');
      } catch (e) {
        // Ошибка сохранения данных пользователя в localStorage
      }
    },
    validateUser(state, payload) {
      try {
        state.user.isLogged = true;
        state.user.token = payload.jwt || localStorage.getItem('lbToken') || null;
        state.user.name = payload.name || localStorage.getItem('lbName') || null;
        state.user.email = payload.email || localStorage.getItem('lbEmail') || null;
        state.user.status = payload.status || localStorage.getItem('lbStatus') || null;
        state.user.role = payload.role || localStorage.getItem('lbRole') || null;
        state.user.id = payload.id || localStorage.getItem('lbId') || null;
        state.user.shopId = payload.shopId || localStorage.getItem('lbShopId') || null;
        state.user.shopName = payload.shopName || localStorage.getItem('lbShopName') || null;
        state.user.shopAddress = payload.shopAddress || localStorage.getItem('lbShopAddress') || null;
      } catch (e) {
        // В случае ошибки используем только переданные данные
        state.user.isLogged = true;
        state.user.token = payload.jwt || null;
        state.user.name = payload.name || null;
        state.user.email = payload.email || null;
        state.user.status = payload.status || null;
        state.user.role = payload.role || null;
        state.user.id = payload.id || null;
        state.user.shopId = payload.shopId || null;
        state.user.shopName = payload.shopName || null;
        state.user.shopAddress = payload.shopAddress || null;
      }
    },
    setValidating(state, isValidating) {
      state.isValidating = isValidating;
    },
    logoutUser(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.role = null;
      state.user.id = null;
      state.user.shopId = null;
      state.user.shopName = null;
      state.user.shopAddress = null;
      
      // Очищаем данные из localStorage
      localStorage.removeItem('lbToken');
      localStorage.removeItem('lbEmail');
      localStorage.removeItem('lbName');
      localStorage.removeItem('lbStatus');
      localStorage.removeItem('lbRole');
      localStorage.removeItem('lbId');
      localStorage.removeItem('lbShopId');
      localStorage.removeItem('lbShopName');
      localStorage.removeItem('lbShopAddress');
      localStorage.removeItem('lbIsLogged');
    },
    clearUserData(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.role = null;
      state.user.id = null;
      state.user.shopId = null;
      state.user.shopName = null;
      state.user.shopAddress = null;
    },

    setUsersPagination(state, payload) {
      state.pagination = {
        page: payload.page,
        limit: payload.limit,
        first: payload.first
      };
    }
  },
  actions: {
    loginUser({ commit }, payload) {
      commit("loginUser", payload);
    },
    async initializeAuth({ commit, state }) {
      // Избегаем повторных запросов, если валидация уже выполняется
      if (state.isValidating) {
        return;
      }

      try {
        commit("setValidating", true);
        
        // Проверяем наличие токена и флага авторизации
        const token = localStorage.getItem("lbToken");
        const isLogged = localStorage.getItem("lbIsLogged");



        if (token && isLogged === 'true') {
          // Восстанавливаем все данные из localStorage
          const payload = {
            jwt: token,
            email: localStorage.getItem("lbEmail"),
            name: localStorage.getItem("lbName"),
            status: localStorage.getItem("lbStatus"),
            role: localStorage.getItem("lbRole"),
            id: localStorage.getItem("lbId"),
            shopId: localStorage.getItem("lbShopId"),
            shopName: localStorage.getItem("lbShopName"),
            shopAddress: localStorage.getItem("lbShopAddress")
          };

          commit("validateUser", payload);
          
          // Выполняем проверку токена на сервере для подтверждения его действительности
          try {
            const response = await api.post('/users/validate', { token });
            
            if (response.data && response.data.success) {
              // Обновляем данные пользователя из ответа сервера
              commit("validateUser", response.data.data || {});
            } else {
              // Если токен недействителен, выполняем выход
              commit("logoutUser");
            }
          } catch (error) {
            // Проверяем, является ли ошибка связанной с токеном
            if (handleTokenError(error)) {
              commit("logoutUser");
              return;
            }
            // В случае других ошибок оставляем пользователя авторизованным с данными из localStorage
          }
        } else {
          commit("clearUserData");
        }
      } catch (e) {
        commit("clearUserData");
      } finally {
        commit("setValidating", false);
      }
    },
    updateUsersPagination({ commit }, pagination) {
      commit('setUsersPagination', pagination);
    }
  },
  modules: {},
};
